import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '@zr/components/Modal';

import './WarningModal.less';

import {
  STRING_WANT_TO_CANCEL_PROMPT,
  STRING_KEEP_GOING,
  STRING_CANCEL,
  STRING_CANCEL_APPLICATION,
  STRING_CANCEL_APPLICATION_EXPLANATION,
  STRING_CANCEL_PROFILE_UPDATE_EXPLANATION,
} from '../../labels';

import screenTypeTelemetry from '../Screens/ScreenTypes/screenTypeTelemetry';
import { WARNING_MODAL } from '../screenTypeSchema';

export function WarningModal({
  applyData,
  isMobile,
  handleWarningGoBackPrompt,
  handleWarningClosePrompt,
  applicationState,
}) {
  useEffect(() => {
    // Log the JobSeeker being presented with the warning modal
    const { logView } = screenTypeTelemetry(WARNING_MODAL, applyData);
    logView();

    return null;
  }, [applyData]);

  const displayExplanationText = () => {
    // We need to update the text for the warning modal depending on what step of the application
    // process the JobSeeker is in
    if (applicationState === 'delivered') {
      // The JobSeeker's application has been sent to the employer. We should let them know that
      // if the JobSeeker chooses to close the modal now, we should let them know that their profile
      // will be in an incomplete state
      return STRING_CANCEL_PROFILE_UPDATE_EXPLANATION;
    }
    // The JobSeeker's application is not complete, so we should let them know that if they
    // stop now, they'll have to complete the application at another time
    return STRING_CANCEL_APPLICATION_EXPLANATION;
  };

  const goBack = () => {
    // Log the interaction
    const { logInteraction } = screenTypeTelemetry(WARNING_MODAL, applyData);
    logInteraction('keep_going');

    // Call the calling class's method
    handleWarningGoBackPrompt();
  };

  const cancelApplication = () => {
    // Log the interaction
    const { logInteraction } = screenTypeTelemetry(WARNING_MODAL, applyData);
    logInteraction('cancel_application');

    // Call the calling class's method
    handleWarningClosePrompt();
  };

  const displayWarningModalButtons = () => {
    let cancelButtonText = STRING_CANCEL_APPLICATION;

    if (applicationState === 'delivered') {
      cancelButtonText = STRING_CANCEL;
    }

    if (isMobile) {
      return (
        <div className="warning_modal_button_wrapper">
          <button type="button" className="primary_button" onClick={goBack}>{STRING_KEEP_GOING}</button>
          <button type="button" className="close_button" onClick={cancelApplication}>{cancelButtonText}</button>
        </div>
      );
    }

    return (
      <div className="warning_modal_button_wrapper">
        <button type="button" className="close_button" onClick={cancelApplication}>{cancelButtonText}</button>
        <button type="button" className="primary_button" onClick={goBack}>{STRING_KEEP_GOING}</button>
      </div>
    );
  };

  return (
    <Modal>
      <div className="warningModal">
        <h2 className="title">{STRING_WANT_TO_CANCEL_PROMPT}</h2>
        {displayExplanationText()}
        {displayWarningModalButtons()}
      </div>
    </Modal>
  );
}

WarningModal.propTypes = {
  applyData: PropTypes.object.isRequired,
  handleWarningGoBackPrompt: PropTypes.func.isRequired,
  handleWarningClosePrompt: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  applicationState: PropTypes.string,
};

WarningModal.defaultProps = {
  applicationState: null,
};

export default WarningModal;
